import type { ModelProperties } from 'mobx-state-tree';
import { applySnapshot } from 'mobx-state-tree';
import type { Instance, SnapshotIn } from 'mobx-state-tree/dist/core/type/type';
import type { IModelType } from 'mobx-state-tree/dist/types/complex-types/model';

import { isServer } from '@/utils/common';

const storeMap = {};

// TODO: try to generify IModelType correctly
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initializeStore = <T extends IModelType<ModelProperties, unknown>>(
  storeModel: T,
  snapshot: SnapshotIn<T> | null = null,
): Instance<T> => {
  let store = storeMap[storeModel?.name];
  const createdStore = store ?? storeModel.create({ lastUpdate: 0 });

  // If your page has Next.js data fetching methods that use a Mobx store, it will
  // get hydrated here
  if (snapshot) {
    applySnapshot(createdStore, snapshot);
  }

  // For SSG and SSR always create a new store
  if (isServer()) {
    return createdStore;
  }

  // Create the store once in the client
  if (!store) {
    store = createdStore;
    storeMap[storeModel.name] = store;
  }

  return store;
};
